homePack = {
    init: function () {
        $(".section-home-pack").each(function () {
            var section = $(this);

            function setBodyHeight(item) {
                item.find(".home-pack-item__body").height(item.find(".home-pack-item__body-inner").outerHeight());
            }

            function setActive(key) {
                var item = section.find('.home-pack-item[data-pack-key="' + key + '"]');

                if (!item.length) {
                    return;
                }

                section.find(".home-pack-item").removeClass("open");
                section.find(".home-pack-item__body").height(0);
                item.addClass("open");
                setBodyHeight(item);

                section.find(".home-pack__media-item").removeClass("active");
                section.find('.home-pack__media-item[data-pack-key="' + key + '"]').addClass("active");

                section.find(".home-pack-tab").removeClass("active");
                section.find('.home-pack-tab[data-pack-key="' + key + '"]').addClass("active");
            }

            section.find(".home-pack-item__label, .home-pack-tab").off("click.homePack").on("click.homePack", function () {
                var key = $(this).data("pack-key") || $(this).closest(".home-pack-item").data("pack-key");
                setActive(key);
            });

            setActive(section.find(".home-pack-item").first().data("pack-key"));

            $(window).off("resize.homePack").on("resize.homePack", function () {
                var openItem = section.find(".home-pack-item.open");
                if (openItem.length) {
                    setBodyHeight(openItem);
                }
            });
        });
    }
};

$(document).ready(function () {
    homePack.init();
});

$(document).on("shopify:section:load", function () {
    homePack.init();
});
